module.exports = __webpack_public_path__ + "static/media/emotions.058409b2.svg";